const DEFAULT_CRM_ORIGIN = 'https://chats.panely.io';

export const getCrmRedirectOrigin = (redirect) => {
  if (!redirect) return DEFAULT_CRM_ORIGIN;

  try {
    const url = new URL(/^https?:\/\//i.test(redirect) ? redirect : `https://${redirect}`);

    if (!url.hostname || url.username || url.password) {
      return DEFAULT_CRM_ORIGIN;
    }

    return url.origin;
  } catch (error) {
    return DEFAULT_CRM_ORIGIN;
  }
};
